export default "__VITE_ASSET__BUlzA3gJ__"